import { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { BaseUrl } from "../../helper/BaseUrl";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const dynamicEditEndpoint = ApiEndpoints.dynamic.dynamicEdit;
const dynamicUpdateEndpoint = ApiEndpoints.dynamic.dynamicUpdate;

export default function EditDynamic() {
  const navigate = useNavigate();
  const [loading, setLoading ] = useState(true);
  const { service_id } = useParams();

  const [previews, setPreviews] = useState({ section1_image: null,});
  const [postData, setPostData] = useState({ 
    section1_title: "", 
    slug: "", 
    section1_tag: "", 
    section1_image: null, 
    section1_alt_image: "", 

    section2_title:"", 
    section2_highlighted_word: "",
    section2_description: "",
    section2_button_text: "",
    section2_button_link: "",

    section3_title: "",
    section3_description: "",
    section3_points: [ { heading: "", description: "", icon: null },], 

    section4_title: "", 
    section4_description: "",
    section4_lefft_side_data: [{
        heading: "",
        description: "",
        cta_link: "",
        icon: null,
        image: null,
        alt_image: "",
      },
    ],

    section5_title: "",
    section5_right_side_data: [
      {
        heading: "",
        description: "",
        icon: null,
        image: null,
        alt_image: "",
      },
    ],

    form_section_title: "",
    form_section_heading: "",

    faqs: [ { question: "", answer: "", },],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiRequest("GET", `${dynamicEditEndpoint}${service_id}`,);
        setPostData(response.service);
        setPreviews((prev) => ({
        ...prev,
        section1_image: response.service.section1_image
          ? BaseUrl + response.service.section1_image
          : null,
      }));

      setLoading(false);

      } catch (error) {
        console.error("Error fetching page data", error);
      }
    };

    fetchData();
  }, [service_id]);


  
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    const finalValue = files ? files[0] : value;
    setPostData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));
    if (files) {
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(files[0]),
      }));
    }
  };


  const handleEditorChange = (key, data) => {
    setPostData((prev) => ({
      ...prev,
      [key]: data,
    }));
  };



  // ================= SECTION 3 =================
  const handleFeatureChange = (index, field, value) => {
    const updated = [...postData.section3_points];
    updated[index][field] = value;

    setPostData((prev) => ({
      ...prev,
      section3_points: updated,
    }));
  };

  const handleAddMoreFeature = (e) => {
    e.preventDefault();
    if (postData.section3_points.length >= 9) {
      toast.warning("Max 9 allowed");
      return;
    }

    setPostData((prev) => ({
      ...prev,
      section3_points: [
        ...prev.section3_points,
        { heading: "", description: "", icon: null, },
      ],
    }));
  };

  const handleRemoveFeature = (index) => {
    if (postData.section3_points.length === 1) return;
    const updated = postData.section3_points.filter((_, i) => i !== index);
    setPostData((prev) => ({
      ...prev,
      section3_points: updated,
    }));
  };


  // ================= SECTION 4 =================

  const handleSection4Change = (index, field, value) => {
    const updated = [...postData.section4_lefft_side_data];

    updated[index][field] = value;

    setPostData((prev) => ({
      ...prev,
      section4_lefft_side_data: updated,
    }));
  };

  const handleAddMoreSection4 = (e) => {
    e.preventDefault();

    if (postData.section4_lefft_side_data.length >= 3) {
      toast.warning("Max 3 allowed");
      return;
    }

    setPostData((prev) => ({
      ...prev,
      section4_lefft_side_data: [
        ...prev.section4_lefft_side_data,
        {
          heading: "",
          description: "",
          cta_link: "",
          icon: null,
          image: null,
          alt_image: "",
        },
      ],
    }));
  };

  const handleRemoveSection4 = (index) => {
    if (postData.section4_lefft_side_data.length === 1) return;

    const updated = postData.section4_lefft_side_data.filter(
      (_, i) => i !== index
    );

    setPostData((prev) => ({
      ...prev,
      section4_lefft_side_data: updated,
    }));
  };


  // ================= SECTION 5 =================

  const handleSection5Change = (index, field, value) => {
    const updated = [...postData.section5_right_side_data];

    updated[index][field] = value;

    setPostData((prev) => ({
      ...prev,
      section5_right_side_data: updated,
    }));
  };

  const handleAddMoreSection5 = (e) => {
    e.preventDefault();

    if (postData.section5_right_side_data.length >= 4) {
      toast.warning("Max 4 allowed");
      return;
    }

    setPostData((prev) => ({
      ...prev,
      section5_right_side_data: [
        ...prev.section5_right_side_data,
        {
          heading: "",
          description: "",
          icon: null,
          image: null,
          alt_image: "",
        },
      ],
    }));
  };

  const handleRemoveSection5 = (index) => {
    if (postData.section5_right_side_data.length === 1) return;

    const updated = postData.section5_right_side_data.filter(
      (_, i) => i !== index
    );

    setPostData((prev) => ({
      ...prev,
      section5_right_side_data: updated,
    }));
  };


  // =================  Faq =================
  const handleFaqChange = (index, field, value) => {
    const updated = [...postData.faqs];
    updated[index][field] = value;

    setPostData((prev) => ({
      ...prev,
      faqs: updated,
    }));
  };

  const handleAddMoreFaq = (e) => {
    e.preventDefault();

    if (postData.faqs.length >= 10) {
      toast.warning("Max 10 allowed");
      return;
    }

    setPostData((prev) => ({
      ...prev,
      faqs: [
        ...prev.faqs,
        { question: "", answer: "" },
      ],
    }));
  };

  const handleRemoveFaq = (index) => {
    if (postData.faqs.length === 1) return;
    const updated = postData.faqs.filter((_, i) => i !== index);
    setPostData((prev) => ({
      ...prev,
      faqs: updated,
    }));
  };


  // ================= SUBMIT =================
    const handleSubmit = async (e) => {
      e.preventDefault();

      const ignoreFields = ["_id", "__v", "createdAt", "updatedAt"];

      // ================= MAIN VALIDATION =================
      for (const [key, value] of Object.entries(postData)) {

        if (ignoreFields.includes(key)) continue;

        // skip array validation here
        if (Array.isArray(value)) continue;

        // CKEditor empty check
        if (
          typeof value === "string" &&
          value.replace(/<(.|\n)*?>/g, "").trim() === ""
        ) {
          toast.error(`${key} is required`);
          return;
        }

        if (!value) {
          toast.error(`${key} is required`);
          return;
        }
      }

      // ================= SECTION 3 VALIDATION =================
      for (let i = 0; i < postData.section3_points.length; i++) {

        const item = postData.section3_points[i];

        const emptyDescription =
          !item.description ||
          item.description.replace(/<(.|\n)*?>/g, "").trim() === "";

        if (
          !item.heading?.trim() ||
          emptyDescription ||
          !item.icon
        ) {
          toast.error(`Section-3 Card ${i + 1} incomplete`);
          return;
        }
      }

      // ================= SECTION 4 VALIDATION =================
      for (let i = 0; i < postData.section4_lefft_side_data.length; i++) {

        const item = postData.section4_lefft_side_data[i];

        const emptyDescription =
          !item.description ||
          item.description.replace(/<(.|\n)*?>/g, "").trim() === "";

        if (
          !item.heading?.trim() ||
          emptyDescription ||
          !item.cta_link?.trim() ||
          !item.icon ||
          !item.image ||
          !item.alt_image?.trim()
        ) {
          toast.error(`Section-4 Card ${i + 1} incomplete`);
          return;
        }
      }

      // ================= SECTION 5 VALIDATION =================
      for (let i = 0; i < postData.section5_right_side_data.length; i++) {

        const item = postData.section5_right_side_data[i];

        const emptyDescription =
          !item.description ||
          item.description.replace(/<(.|\n)*?>/g, "").trim() === "";

        if (
          !item.heading?.trim() ||
          emptyDescription ||
          !item.icon ||
          !item.image ||
          !item.alt_image?.trim()
        ) {
          toast.error(`Section-5 Card ${i + 1} incomplete`);
          return;
        }
      }

      // ================= FAQ VALIDATION =================
      for (let i = 0; i < postData.faqs.length; i++) {

        const item = postData.faqs[i];

        const emptyAnswer =
          !item.answer ||
          item.answer.replace(/<(.|\n)*?>/g, "").trim() === "";

        if (
          !item.question?.trim() ||
          emptyAnswer
        ) {
          toast.error(`FAQ Card ${i + 1} incomplete`);
          return;
        }
      }

      // ================= FORM DATA =================
      const formData = new FormData();

      Object.entries(postData).forEach(([key, value]) => {

        if (ignoreFields.includes(key)) return;

        // ===== ARRAY DATA =====
        if (Array.isArray(value)) {

          value.forEach((item, i) => {

            Object.entries(item).forEach(([subKey, subValue]) => {

              // skip null/undefined
              if (subValue === null || subValue === undefined) return;

              formData.append(
                `${key}[${i}][${subKey}]`,
                subValue
              );

            });

          });

        } else {

          // ===== NORMAL FIELD =====
          formData.append(key, value);

        }
      });

      // ================= API =================
      try {

        const response = await ApiRequest("POST", `${dynamicUpdateEndpoint}${service_id}`, formData,{
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

        toast.success(response.message);

        navigate("/dynamic");

      } catch (error) {

        toast.error(
          error.response?.data?.message || "Error updating the dynamic page"
        );

        console.error("Error submitting form:", error);
      }
    };


    const pagename = {
      name: 'Dynamic Page',
      user: 'Admin',
      innerpage: 'Dynamic Page / Edit page'
    }

  if(loading){return null;}
  

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-content-page">
        <form id="dynamicEdit" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
                <div className="col-lg-12">
                  <h4 className="heading-text mb-0">Section 1</h4>
                </div>

                <div className="col-lg-6">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Title<small>*</small></label>
                    </div>
                    <input onChange={handleChange} value={postData?.section1_title} name="section1_title" type="text" className="form-control" placeholder="Enter Title" />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>slug<small>*</small></label>
                    </div>
                    <input onChange={handleChange} value={postData?.slug} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                  </div>
                </div>
              
                <div className="col-lg-6">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Tagline<small>*</small></label>
                    </div>
                    <input onChange={handleChange} value={postData?.section1_tag} name="section1_tag" type="text" className="form-control" placeholder="Enter Tagline" />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Image Alt Tag<small>*</small></label>
                    </div>
                    <input onChange={handleChange} value={postData?.section1_alt_image} name="section1_alt_image" type="text" className="form-control" placeholder="Alt Tag" />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="add-page-inputs input-add-image">
                    <div className="label-wrap-add">
                      <label>Image (1680 × 840)<small>*</small></label>
                    </div>
                    <CustomImageUpload name="section1_image"
                      acceptedFormats={[".webp"]}
                      onImageChange={handleChange}
                      requiredWidth={1680}
                      requiredHeight={840}
                      imagePreview={previews.section1_image} />
                  </div>
                </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
                <div className="col-lg-12">
                  <h4 className="heading-text mb-0">Section 2</h4>
                </div>

                <div className="col-lg-6">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Title<small>*</small></label>
                    </div>
                    <input onChange={handleChange} value={postData?.section2_title} name="section2_title" type="text" className="form-control" placeholder="Enter Title" />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>highlighted word<small>*</small></label>
                    </div>
                    <input onChange={handleChange} value={postData?.section2_highlighted_word} name="section2_highlighted_word" type="text" className="form-control" placeholder="Enter Highlighted Word" />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Description <small>*</small></label>
                    </div>
                    <DynamicCKEditor data={postData.section2_description} onChange={(event, editor) => handleEditorChange("section2_description", editor?.getData())} />
                  </div>
                </div>
              
                <div className="col-lg-6">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Button Text <small>*</small></label>
                    </div>
                    <input onChange={handleChange} value={postData?.section2_button_text} name="section2_button_text" type="text" className="form-control" placeholder="Enter Button Text" />
                  </div>
                </div>
 
                <div className="col-lg-6">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Button Link <small>*</small></label>
                    </div>
                    <input onChange={handleChange} value={postData?.section2_button_link} name="section2_button_link" type="text" className="form-control" placeholder="Enter Button Link" />
                  </div>
                </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                  <h4 className="heading-text mb-0">Section 3</h4>
              </div>

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Heading<small>*</small></label>
                  </div>
                  <input onChange={handleChange} value={postData?.section3_title} name="section3_title" type="text" className="form-control" placeholder="Enter Heading" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.section3_description} onChange={(event, editor) => handleEditorChange("section3_description", editor?.getData())} />
                </div>
              </div>

              {postData.section3_points.map((item, index) => (
                <div key={index} className="col-md-4">
                  <div className="add-page-inputs input-add-image">
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> Title <small>*</small></label>
                      </div>
                      <input className="form-control" placeholder="Title" value={item.heading}
                        onChange={(e) => handleFeatureChange(index, "heading", e.target.value)} />
                    </div>
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> Description <small>*</small></label>
                      </div>
                      <DynamicCKEditor data={item.description} onChange={(e, editor) =>
                        handleFeatureChange(index, "description", editor.getData())} />
                    </div>
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> Icon (90*90)<small>*</small></label>
                      </div>
                      <CustomImageUpload
                        acceptedFormats={[".webp"]}
                        requiredWidth={90}
                        requiredHeight={90}
                        onImageChange={(e) => handleFeatureChange(index, "icon", e.target.files[0])}
                        imagePreview={
                          item.icon
                            ? typeof item.icon === "string"
                              ? BaseUrl + item.icon
                              : URL.createObjectURL(item.icon)
                            : null
                        } />
                    </div>
                  </div>
                  {postData.section3_points.length > 1 && (
                    <button className="remove-btn" onClick={() => handleRemoveFeature(index)}>Remove </button>
                  )}
                </div>
              ))}
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <Link className="addmore-images-client" onClick={handleAddMoreFeature}>
                    Add More +
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                  <h4 className="heading-text mb-0">Section 4</h4>
              </div>

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Heading<small>*</small></label>
                  </div>
                  <input onChange={handleChange} value={postData?.section4_title} name="section4_title" type="text" className="form-control" placeholder="Enter Heading" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData?.section4_description} onChange={(event, editor) => handleEditorChange("section4_description", editor?.getData())} />
                </div>
              </div>


              {postData.section4_lefft_side_data.map((item, index) => (
                <div key={index} className="col-md-12">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Title<small>*</small></label>
                        </div>
                        <input className="form-control" placeholder="Title" value={item.heading}
                          onChange={(e) => handleSection4Change(index, "heading", e.target.value)} />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Button Link<small>*</small></label>
                        </div>
                        <input className="form-control" placeholder="Button Link" value={item.cta_link}
                          onChange={(e) => handleSection4Change(index, "cta_link", e.target.value)} />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Image Alt Text <small>*</small></label>
                        </div>
                        <input className="form-control" placeholder="Alt Text" value={item.alt_image}
                          onChange={(e) => handleSection4Change(index, "alt_image", e.target.value)} />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Description<small>*</small></label>
                        </div>
                        <DynamicCKEditor data={item.description} onChange={(e, editor) =>
                          handleSection4Change(index, "description", editor.getData())} />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Icon (40*40)<small>*</small></label>
                        </div>
                        <CustomImageUpload
                          acceptedFormats={[".webp"]}
                          requiredWidth={40}
                          requiredHeight={40}
                          onImageChange={(e) => handleSection4Change(index, "icon", e.target.files[0])}
                          imagePreview={
                          item.icon
                            ? typeof item.icon === "string"
                              ? BaseUrl + item.icon
                              : URL.createObjectURL(item.icon)
                            : null
                        } />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Image (758*664)<small>*</small></label>
                        </div>
                        <CustomImageUpload
                          acceptedFormats={[".webp"]}
                          requiredWidth={758}
                          requiredHeight={664}
                          onImageChange={(e) => handleSection4Change(index, "image", e.target.files[0])}
                          imagePreview={
                            item.image
                              ? typeof item.image === "string"
                                ? BaseUrl + item.image
                                : URL.createObjectURL(item.image)
                              : null
                          }/>
                      </div>
                    </div>
                  </div>

                  {postData.section4_lefft_side_data.length > 1 && (
                    <button className="remove-btn" onClick={() => handleRemoveSection4(index)}>Remove </button>
                  )}

                  <div className="col-lg-12"><hr/></div>
                </div>
              ))}
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <Link className="addmore-images-client" onClick={handleAddMoreSection4}>
                    Add More +
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                  <h4 className="heading-text mb-0">Section 5</h4>
              </div>

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Section Heading<small>*</small></label>
                  </div>
                  <input onChange={handleChange} value={postData?.section5_title} name="section5_title" type="text" className="form-control" placeholder="Enter Heading" />
                </div>
              </div>


              {postData.section5_right_side_data.map((item, index) => (
                <div key={index} className="col-md-12">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Title<small>*</small></label>
                        </div>
                        <input className="form-control" placeholder="Title" value={item.heading}
                          onChange={(e) => handleSection5Change(index, "heading", e.target.value)} />
                      </div>
                    </div>  

                    <div className="col-md-6">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Image Alt Text <small>*</small></label>
                        </div>
                        <input className="form-control" placeholder="Alt Text" value={item.alt_image}
                          onChange={(e) => handleSection5Change(index, "alt_image", e.target.value)} />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Description<small>*</small></label>
                        </div>
                        <DynamicCKEditor data={item.description} onChange={(e, editor) =>
                          handleSection5Change(index, "description", editor.getData())} />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Icon (40*40)<small>*</small></label>
                        </div>
                        <CustomImageUpload
                          acceptedFormats={[".webp"]}
                          requiredWidth={40}
                          requiredHeight={40}
                          onImageChange={(e) => handleSection5Change(index, "icon", e.target.files[0])}
                          imagePreview={
                          item.icon
                            ? typeof item.icon === "string"
                              ? BaseUrl + item.icon
                              : URL.createObjectURL(item.icon)
                            : null
                        } />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Image (696*555)<small>*</small></label>
                        </div>
                        <CustomImageUpload
                          acceptedFormats={[".webp"]}
                          requiredWidth={696}
                          requiredHeight={555}
                          onImageChange={(e) => handleSection5Change(index, "image", e.target.files[0])}
                          imagePreview={
                            item.image
                              ? typeof item.image === "string"
                                ? BaseUrl + item.image
                                : URL.createObjectURL(item.image)
                              : null
                          } />
                      </div>
                    </div>
                  </div>

                  {postData.section5_right_side_data.length > 1 && (
                    <button className="remove-btn" onClick={() => handleRemoveSection5(index)}>Remove </button>
                  )}

                  <div className="col-lg-12"><hr/></div>
                </div>
              ))}
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <Link className="addmore-images-client" onClick={handleAddMoreSection5}>
                    Add More +
                  </Link>
                </div>
              </div>
            </div>
          </div>
          
          <div className="add-content-wrap">
            <div className="row">
                <div className="col-lg-12">
                  <h4 className="heading-text mb-0">Contact Form Section</h4>
                </div>

                <div className="col-lg-6">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Sub Title<small>*</small></label>
                    </div>
                    <input onChange={handleChange} value={postData?.form_section_title} name="form_section_title" type="text" className="form-control" placeholder="Enter Title" />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Heading<small>*</small></label>
                    </div>
                    <input onChange={handleChange} value={postData?.form_section_heading} name="form_section_heading" type="text" className="form-control" placeholder="Enter Heading" />
                  </div>
                </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <h4 className="heading-text mb-0" > FAQ </h4>
              </div>
              {postData.faqs.map((item, index) => (
                <div key={index} className="col-md-6">
                  <div className="add-page-inputs input-add-image">
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> question<small>*</small></label>
                      </div>
                      <input placeholder="question" className="form-control" value={item.question} onChange={(e) => handleFaqChange(index, "question", e.target.value)} />
                    </div>
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> answer<small>*</small></label>
                      </div>
                      <DynamicCKEditor data={item.answer} onChange={(e, editor) =>
                        handleFaqChange(index, "answer", editor.getData())} />
                    </div>
                    {postData.faqs.length > 1 && (
                      <button className="remove-btn" onClick={() => handleRemoveFaq(index)}>    Remove   </button>
                    )}
                  </div>
                </div>
              ))}
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <Link className="addmore-images-client" onClick={handleAddMoreFaq}>
                    Add More +
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </form>

        <button type="submit" form="dynamicEdit" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}

